import React, { useRef, useState, useEffect } from 'react';
import './Carx.css';
import { useParams, useNavigate } from 'react-router-dom';
import { FaMotorcycle } from 'react-icons/fa';
import BiletController from '../../../../api/lotoreya/BiletController';
import CarxController from '../../../../api/lotoreya/CarxController';
import UserController from '../../../../api/user/UserController';
import LotoreyaController from '../../../../api/lotoreya/LotoreyaController';

const Carx = () => {
    const wheelRef = useRef(null);
    const [isSpinning, setIsSpinning] = useState(false);
    const [lotoreyaBilets, setLotoreyaBilets] = useState([]);
    const [selectedBilets, setSelectedBilets] = useState([]);
    const [eliminationBilets, setEliminationBilets] = useState([]);
    const [eliminatedBilets, setEliminatedBilets] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [winnerInfo, setWinnerInfo] = useState(null);
    const [winnerUserInfo, setWinnerUserInfo] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showEndModal, setShowEndModal] = useState(false);
    const { lotoreyaId } = useParams();
    const navigate = useNavigate();
    const storageKey = `LotoreyaCarx_SelecteBilet_${lotoreyaId}`;

    useEffect(() => {
        if (lotoreyaId) {
            BiletController.getBiletsByLotoreyaId(lotoreyaId)
                .then(data => {
                    setLotoreyaBilets(data);
                    const saved = localStorage.getItem(storageKey);
                    if (saved) {
                        setSelectedBilets(JSON.parse(saved));
                    }
                })
                .catch(error => console.error('Biletlər yüklənərkən xəta:', error));
        }
    }, [lotoreyaId, storageKey]);

    useEffect(() => {
        if (lotoreyaId) {
            LotoreyaController.getLotoreyaById(lotoreyaId)
                .then(async (lotoreya) => {
                    if (lotoreya?.carx?.winnerUserId) {
                        setWinnerInfo(lotoreya.carx);
                        try {
                            const user = await UserController.getUserById(lotoreya.carx.winnerUserId);
                            setWinnerUserInfo(user);
                        } catch (err) {
                            console.error("Qalib istifadəçi tapılmadı", err);
                        }
                        setShowEndModal(true); // yalnız bu modal göstəriləcək
                    }
                })
                .catch(err => {
                    console.error("Lotoreya məlumatı yüklənmədi:", err);
                });
        }
    }, [lotoreyaId]);

    useEffect(() => {
        if (selectedBilets.length === 3) {
            setEliminationBilets([...selectedBilets]);
        }
    }, [selectedBilets]);

    const spinWheel = () => {
        if (isSpinning) return;

        const sourceBilets = selectedBilets.length < 3 ? lotoreyaBilets : eliminationBilets;
        if (sourceBilets.length === 0) return;

        setIsSpinning(true);

        const rotations = selectedBilets.length < 3 ? 60 : 40;
        const duration = selectedBilets.length < 3 ? 10000 : 7000;
        const intervalLimit = selectedBilets.length < 3 ? 100 : 70;
        const stopAngle = Math.floor(Math.random() * 360);
        const deg = (360 * rotations) + stopAngle;

        wheelRef.current.style.transition = 'none';
        wheelRef.current.style.transform = 'rotate(0deg)';

        setTimeout(() => {
            wheelRef.current.style.transition = `transform ${duration / 1000}s linear`;
            wheelRef.current.style.transform = `rotate(${deg}deg)`;
        }, 50);

        let i = 0;
        const interval = setInterval(() => {
            setCurrentIndex(prev => (prev + 1) % sourceBilets.length);
            i++;
            if (i >= intervalLimit) {
                clearInterval(interval);

                if (selectedBilets.length < 3) {
                    const available = lotoreyaBilets.filter(b => !selectedBilets.some(sb => sb.id === b.id));
                    if (available.length === 0) {
                        alert('Bütün biletlər artıq seçilib!');
                        return;
                    }
                    const randomBilet = available[Math.floor(Math.random() * available.length)];
                    const updated = [...selectedBilets, randomBilet];
                    setSelectedBilets(updated);
                    localStorage.setItem(storageKey, JSON.stringify(updated));
                    alert(`✅ Seçilmiş Bilet: ${randomBilet.code}`);
                } else {
                    const randomIndex = Math.floor(Math.random() * eliminationBilets.length);
                    const eliminated = eliminationBilets[randomIndex];
                    alert(`❌ Ələnmiş Bilet: ${eliminated.code}`);
                    const updated = eliminationBilets.filter(b => b.id !== eliminated.id);
                    setEliminationBilets(updated);
                    setEliminatedBilets(prev => [...prev, eliminated]);

                    if (updated.length === 1 && eliminatedBilets.length > 0) {
                        const lastTwoCodes = [updated[0].code, eliminatedBilets[eliminatedBilets.length - 1].code];
                        CarxController.assignWinner(lotoreyaId, lastTwoCodes).then(async winner => {
                            console.log("Qalib məlumatı:", winner);
                            if (winner) {
                                setWinnerInfo(winner);
                                try {
                                    const user = await UserController.getUserById(winner.winnerUserId);
                                    setWinnerUserInfo(user);
                                } catch (e) {
                                    console.error("İstifadəçi tapılmadı", e);
                                }
                                setShowModal(true);
                            }
                        });
                    }
                }
            }
        }, 100);

        setTimeout(() => {
            setIsSpinning(false);
        }, duration);
    };

    const displayBilets = selectedBilets.length < 3 ? lotoreyaBilets : eliminationBilets;

    return (
        <div className="carx-container">
            <div className="bilet-box">
                {displayBilets.length > 0 ? (
                    <div className="scrolling-code">🎟️ {displayBilets[currentIndex]?.code}</div>
                ) : (
                    <div className="scrolling-code">Bilet yoxdur</div>
                )}
            </div>

            {showEndModal && winnerInfo && (
                <div className="winner-modal">
                    <div className="winner-modal-content">
                        <h2>⚠️ Lotoreya artıq başa çatıb</h2>
                        <p><strong>Qalib Bilet:</strong> {winnerInfo.winnerBiletCode}</p>
                        {winnerUserInfo && (
                            <p>
                                <strong>İstifadəçi: </strong>
                                <a
                                    href={`/private/istifadeciler/${winnerUserInfo.id}`}
                                    className="winner-profile-link"
                                >
                                    👤 {winnerUserInfo.name}
                                </a>
                            </p>
                        )}
                        <button onClick={() => navigate(-1)}>🔙 Geri Qayıt</button>
                    </div>
                </div>
            )}

            <div className="main-content">
                <div className="side-boxes">
                    <div className="selected-bilets-box">
                        <h3>🎟️ Seçilmiş Biletlər</h3>
                        {selectedBilets.length === 0 ? (
                            <p>Hələ bilet seçilməyib.</p>
                        ) : (
                            <ul>
                                {selectedBilets.map((b, i) => <li key={b.id}>{i + 1}. {b.code}</li>)}
                            </ul>
                        )}
                    </div>

                    {selectedBilets.length >= 3 && (
                        <div className="elimination-box">
                            <h3>🏆 Ələmə Mərhələsi (Qalan: {eliminationBilets.length})</h3>
                            <ul>
                                {eliminationBilets.map((b, i) => <li key={b.id}>{i + 1}. {b.code}</li>)}
                            </ul>
                            {eliminatedBilets.length > 0 && (
                                <>
                                    <hr style={{ margin: '10px 0' }} />
                                    <h4 style={{ color: '#c0392b' }}>Ələnmiş Biletlər:</h4>
                                    <ul>
                                        {eliminatedBilets.map((b, i) => (
                                            <li key={b.id} style={{ color: '#c0392b' }}>❌ {b.code}</li>
                                        ))}
                                    </ul>
                                </>
                            )}
                        </div>
                    )}

                    {eliminationBilets.length === 1 && (
                        <div className="winner-box">
                            <h3>🏆 Qalib Bilet</h3>
                            <p>{eliminationBilets[0].code}</p>
                            <div className="confetti">🎉 🎉 🎉</div>
                        </div>
                    )}
                </div>

                <div id="main" className="main">
                    <div id="wheel" className="wheel" ref={wheelRef}>
                        <div>
                            <span className="span1"></span>
                            <span className="span2"></span>
                            <span className="span3"></span>
                            <span className="span4"></span>
                            <span className="span5"></span>
                            <span className="span6"></span>
                            <span className="span7"></span>
                            <span className="span8"></span>
                        </div>
                    </div>
                    <button className="spin" onClick={spinWheel}>
                        {!isSpinning ? 'ÇEVİR' : <FaMotorcycle className="spin-icon" />}
                    </button>
                </div>
            </div>

            {showModal && winnerInfo && (
                <div className="winner-modal">
                    <div className="winner-modal-content">
                        <h2>🏆 Qalib təyin edildi!</h2>
                        <p><strong>Bilet:</strong> {winnerInfo.winnerBiletCode}</p>
                        {winnerUserInfo && (
                            <p>
                                <strong>İstifadəçi: </strong>
                                <a
                                    href={`/private/istifadeciler/${winnerUserInfo.id}`}
                                    className="winner-profile-link"
                                >
                                    👤 {winnerUserInfo.name}
                                </a>

                            </p>
                        )}
                        <button onClick={() => setShowModal(false)}>Bağla</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Carx;

